module.exports = __webpack_public_path__ + "img/logo1.21ad2d2f.png";